import { useState } from 'react'
import { PillTabs } from '../../components/ui'
import { ENABLE_SUPPORT } from '../../lib/config'
import { AdminMessaging } from './AdminMessaging'
import { AdminSupport } from './AdminSupport'

const SUB_TABS = [
  { key: 'messaging', label: 'Messaging' },
  ...(ENABLE_SUPPORT ? [{ key: 'support' as const, label: 'Support' }] : []),
] as const

type SubTab = typeof SUB_TABS[number]['key']

export function AdminCommunicationHub() {
  const [sub, setSub] = useState<SubTab>('messaging')

  return (
    <div>
      <PillTabs tabs={[...SUB_TABS]} active={sub} onChange={setSub} style={{ marginBottom: '1.25rem' }} />
      {sub === 'messaging' && <AdminMessaging />}
      {ENABLE_SUPPORT && sub === 'support' && <AdminSupport />}
    </div>
  )
}
